export default {
  menu: 'Opening Balance Sheet',
  title: 'Opening Balance Sheet',

  labels: {
    assets: 'Assets',
    liabilities: 'Liabilities',
    equity: 'Capital'
  },

  accountsLabel: {
    cash_and_bank_assets_menu: 'Cash and bank assets',
    cash_and_bank_assets: {
      bank: 'Bank',
      cash: 'Cash'
    },
    warehouse_inventory_menu: 'Inventory',
    warehouse_inventory: {
      main: 'Main warehouse'
    },
    accounts_receivable: 'Accounts receivable',
    accounts_payable: 'Accounts payable',
    capital: 'Capital'
  },

  notifications: {
    locked: 'is the opening balance of the lock',
    unLocked: 'The opening balance is not locked',
    lock: {
      success: 'Balance sheet successfully locked',
      error: 'Balance sheet error encountered'
    },
    unlock: {
      success: 'Balance sheet successfully opened',
      error: 'Balance sheet opening encountered an error'
    }
  },

  confirmations: {
    unlock: {
      title: 'Confirmation of opening balance',
      body: 'Are you sure you want to open the opening balance?'
    },
    unlockRemainTime: {
      title: 'Confirmation of lock opening balance',
      body: 'Due to the possibility of human error in the initial registration of the course, you have the option to unlock the opening balance within a maximum of {day} days to make any necessary changes.',
      bodyToday: 'Due to the possibility of human error in the initial registration of the course, you have the option to unlock the opening balance by the end of today to make any necessary changes.'
    }
  }
}
